module.exports = __webpack_public_path__ + "img/login-logo.c5b6de7f.png";